import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import RaffleAncolMonthContent from "modules/RaffleAncolMonth";
import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const RaffleAncolMonthPage: React.FC = () => {
  setTitle("Raffle Monthly");
  return (
    <Auth>
      <Layout>
        <RaffleAncolMonthContent />
      </Layout>
    </Auth>
  );
};

export default RaffleAncolMonthPage;
